"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactDownloadCard = void 0;
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _item = require("@design/ui/item");
var _jsxRuntime = require("react/jsx-runtime");
var ArtifactDownloadCard = exports.ArtifactDownloadCard = function ArtifactDownloadCard(_ref) {
  var downloadLine = _ref.downloadLine,
    onDownload = _ref.onDownload;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_item.Item, {
    "data-testid": "artifact-download-card",
    variant: "outline",
    size: "sm",
    className: "mt-3",
    "data-sentry-element": "Item",
    "data-sentry-component": "ArtifactDownloadCard",
    "data-sentry-source-file": "ArtifactDownloadCard.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemMedia, {
      variant: "icon",
      "data-sentry-element": "ItemMedia",
      "data-sentry-source-file": "ArtifactDownloadCard.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DownloadIcon, {
        "data-sentry-element": "DownloadIcon",
        "data-sentry-source-file": "ArtifactDownloadCard.tsx"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemContent, {
      "data-sentry-element": "ItemContent",
      "data-sentry-source-file": "ArtifactDownloadCard.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemTitle, {
        "data-sentry-element": "ItemTitle",
        "data-sentry-source-file": "ArtifactDownloadCard.tsx",
        children: "File ready for download"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_item.ItemActions, {
      "data-sentry-element": "ItemActions",
      "data-sentry-source-file": "ArtifactDownloadCard.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
        type: "button",
        size: "sm",
        onClick: function onClick() {
          return onDownload(downloadLine);
        },
        "data-sentry-element": "Button",
        "data-sentry-source-file": "ArtifactDownloadCard.tsx",
        children: ["Download ", downloadLine.filename]
      })
    })]
  });
};